export default __webpack_public_path__ + "static/media/rocket_anim_20.8373ae1a.png";